<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}

.menu-dragbox .vs-list--item {
  background: #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
}

.menu-dragbox {
  height: 340px;
  overflow-y: scroll;
}

.vs-list--item {
  position: relative;
}
/*.vs-input-primary {
  position: absolute;
  left: 4px;
  top: 0;
}*/
.menu-editwrap span:first-child {
  display: inline-flex;
  height: 100%;
  background: transparent;
  margin-left: 10px;
  color: #cc8899;
  padding: 4px 14px;
  margin-top: 0;
  border-radius: 3px;
}
.menu-editwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
<template>
  <div id="group-user-list">
    <div class="header-custome">
      <h3>Groups</h3>
      <!--<div class="knowlg-base-wrap-sec">
        <a href="/groups/knowledge-base/category-groups/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span> Need help with this section?
        </a>
      </div>-->
    </div>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div>
      </div>
    </vx-card>-->

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentGroup * paginationGroupSize - (paginationGroupSize - 1) }} - {{ groupData.length - currentGroup * paginationGroupSize > 0 ? currentGroup * paginationGroupSize : groupData.length }} of {{ groupData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetGroupSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetGroupSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetGroupSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetGroupSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD -->
        <vs-button class="mr-4" color="rgb(76, 139, 246)" type="filled" @click="popupAddGroup=true">Add Group</vs-button>
        <vs-button color="primary" type="border mr-4" @click="popupActive = true">Bulk Import</vs-button
                    >
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>InActive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="exportGroup">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Export</span>
              </span>
            </vs-dropdown-item>

            <!--
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
            -->
          </vs-dropdown-menu>
        </vs-dropdown>
        

      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="groupData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationGroupSize="paginationGroupSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalGroups" :max="7" v-model="currentGroup" />
    </div>


    <vs-popup class="holamundo" title="Add Group" :active.sync="popupAddGroup" >
      <div class="vx-row">
        <div class="vx-col md:w-9/12 w-full">
          <label>
            Group Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="inputx w-full"
            name="Group Name"
            v-model="GroupName"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Group Name')"
          >{{ errors.first('Group Name') }}</span>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-6">
          <vs-button color="rgb(76, 139, 246)" type="filled" @click="addRecord">Save</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Import Groups" :active.sync="popupActive">
      <div class="import-attendee-wrapper">
        <div class="template-download">
          <h4>Download the template</h4>
          <a
            color="primary"
            type="filled"
            class="mt-3 btn"
            href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Group.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
            >Download</a
          >
        </div>
        <div class="upload-file mt-5">
          <h4>Upload your file</h4>
          <div class="file-up-section">
            <p>Select XLSX file</p>
            <input
              type="file"
              id="group_file"
              accept=".csv,.xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <vs-button
              color="rgb(76, 139, 246)" type="filled"
              class="sub-btn"
              v-on:click="UploadGroup"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import draggable from "vuedraggable";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererChangeStatusGroup from "./cell-renderer/CellRendererChangeStatusGroup.vue";
import CellRendererGroupActions from "./cell-renderer/CellRendererGroupActions.vue";

//console.log(db);

export default {
  components: {
    draggable,
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererChangeStatusGroup,
    CellRendererGroupActions,
  },
  data() {
    return {
      CategoryColor: "",
      TextBoxShowingId: -1,
      CategoryList: [],
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],
      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],
      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      searchQuery: "",

      popupActive: false,
      popupActive2: false,
      popupAddGroup: false,
      GroupName: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'GroupId',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Name",
          field: "GroupName",
          filter: true,
          width: 300,
        }, 
         {
          headerName: "Attendees",
          field: "Attendees",
          cellRenderer: (data) => {
            return data.value ? data.value.length : 0
          },
          filter: true,
        },         
        { 
          headerName: "Status",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererChangeStatusGroup",
          cellRendererParams: (params) => {
            let Group = {
              GroupId: params.data.GroupId,                
              GroupName: params.data.GroupName
            }
            return { Group: Group };
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 200,
          cellRendererFramework: "CellRendererGroupActions",
          cellRendererParams: (params) => {
            return { group: params.data };
          },
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererChangeStatusGroup,
        CellRendererGroupActions,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    groupData() {
      return this.$store.state.agendaManagement.groups;
    },
    paginationGroupSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalGroups() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentGroup: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {   
  UploadGroup: function () {
      var files = document.getElementById("group_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "group");
    }, 
    addRecord() {
      let GroupName = this.GroupName
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.$store
            .dispatch("agendaManagement/addGroup", {
              GroupName: GroupName
            })
            .then((res) => {
              //console.log(res)
              this.$vs.loading.close();
              if(res.status == 200)
              {
                this.popupAddGroup = false 
                this.$vs.notify({
                  color: "success",
                  position: "top-center",
                  title: "Status",
                  text: "Group created successfully.",
                }); 
                this.$router.push({ 
                  name: 'group-edit', 
                  params: {
                            GroupId: res.Group.GroupId
                          } 
                })
              }
            })
        }
      })
      
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("agendaManagement/updateStatus", {
            IsPublished: Status,
            groups: selectedRows
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("agendaManagement/fetchGroups");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    exportGroup(){   
      let selectedRows = this.gridApi.getSelectedRows();     
        if(selectedRows.length){
          var datarow = [];

          datarow.push("Group Id");
          datarow.push("Group Name");
          datarow.push("Attendee FirstName"); 
          datarow.push("Attendee LastName"); 
          datarow.push("Attendee Email");             
          datarow.push("Status");             
          var AttendeeData = [];
          AttendeeData.push(datarow);

          selectedRows.map((row) => {
            //---------------------------------------------------------
            datarow = [];
            if(row.Attendees && row.Attendees.length)
            {
              row.Attendees.map(Arow=>{
                datarow = [];
                datarow.push(row.GroupId ? `${row.GroupId}` : null);          
                datarow.push(row.GroupName ? `${row.GroupName}` : null);
                datarow.push(Arow.FirstName ? `${Arow.FirstName}` : null);   
                datarow.push(Arow.LastName ? `${Arow.LastName}` : null);   
                datarow.push(Arow.Email ? `${Arow.Email}` : null);   
                datarow.push(row.IsPublished ? 'Active' : 'Inactive');
                AttendeeData.push(datarow);
              })
            }
            else
            {
              datarow = [];
              datarow.push(row.GroupId ? `${row.GroupId}` : null);          
              datarow.push(row.GroupName ? `${row.GroupName}` : null);
              datarow.push(null);
              datarow.push(null);
              datarow.push(null);
              datarow.push(row.IsPublished ? 'Active' : 'Inactive');    
              AttendeeData.push(datarow);           
            }            
            //---------------------------------------------------------
          });
          debugger;
          let csvContent = "data:text/csv;charset=utf-8,";
          var dt = new Date().toISOString().slice(0, 10);
          AttendeeData.forEach(function (rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });
          var filename = "ExportGroup" + "_" + dt + ".csv";
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          //link.setAttribute("id", "Participance_RT_" + row.TableId);
          link.setAttribute("download", filename);
          document.body.appendChild(link); // Required for FF

          link.click();
        }
        else
        {
          alert("Please select any row!");
        }

    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    this.$store.dispatch("agendaManagement/fetchGroups").catch((err) => {
      console.error(err);
    });
  },
};
</script>

<style lang="scss">
#group-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>